var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dialog)?_c('div',{staticClass:"loader"},[_c('div',{staticClass:"centerScreen"},[_c('el-progress',{attrs:{"type":"circle","percentage":_vm.percent}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }